import { createActionGroup, props } from '@ngrx/store';
import { WebsocketOpTypes } from '@qtek/core/websockets-core';
import { EntityMeta, Item, Message, UserApproval } from '@qtek/shared/models';

export const ItemActions = createActionGroup({
  source: 'Item',
  events: {
    'Subscribe Item': props<{
      q?: any[];
      view?: string;
      mysid?: string;
      prms?: Record<string, string>;
      op?: Extract<WebsocketOpTypes, 'sub' | 'fast_query'>;
    }>(),
    'Unsubscribe Item': props<{ mysid?: string }>(),
    'Connect Item': props<{ payload: any }>(),
    'Disconnect Item': props<{ payload: any }>(),
    'Create Item': props<{ payload: Item }>(),
    'Create Item Failure': props<{ payload: any }>(),
    'Create Item Success': props<{
      res: Item;
      mysid: string;
      message: Message;
    }>(),
    'Get Items': props<{ payload: any }>(),
    'Get Items Failure': props<{ payload: any }>(),
    'Get Items Success': props<{
      res: Item[];
      meta: EntityMeta;
      mysid: string;
    }>(),
    'Get Item': props<{ id: string; view?: string; mysid?: string }>(),
    'Get Item Failure': props<{ payload: any }>(),
    'Get Item Success': props<{ res: Item; mysid: string }>(),
    'Update Item': props<{ payload: Item; id: string; mysid?: string }>(),
    'Update Item Failure': props<{ payload: any; mysid?: string }>(),
    'Update Item Success': props<{
      res: Item;
      mysid: string;
      message: Message;
    }>(),
    'Delete Item': props<{ payload: number | string }>(),
    'Delete Item Failure': props<{ payload: any }>(),
    'Delete Item Success': props<{
      res: Item;
      mysid: string;
      message: Message;
    }>(),
    'Mint Item': props<{ payload: number }>(),
    'Mint Item Failure': props<{ payload: any }>(),
    'Mint Item Success': props<{ payload: any }>(),
    'Send Nda Event': props<{
      parId: string;
      userApproval: UserApproval;
    }>(),
    'Send Nda Event Failure': props<{ payload: any }>(),
    'Send Nda Event Success': props<{ payload: any }>(),
  },
});
